import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime4 } from '@/utils/date'

export const mulAcctReceiptViewMixin = {
  data() {
    return {
      mulAcctRcptFilterForm: {
        branch: null,
        accountNo: null,
        documentNo: null,
        transactionDateFrom: null,
        transactionDateTo: null,
        currency: null
      },
      mulAcctRcptFilterLabel: {
        branch: 'Branch',
        accountNo: 'Account No.',
        documentNo: 'Document No.',
        transactionDateFrom: 'Transaction Date From',
        transactionDateTo: 'Transaction Date To',
        currency: 'Currency'
      },
      mulAcctRcptForm: {
        accountList: [],
        branch: null,
        accountNo: null,
        documentNo: null,
        docAE: true,
        documentNoDisabled: null,
        transactionType: null,
        fund: null,
        accountNoSuffix: '',
        accountNoSuffixDesc: '',
        transactionDate: null,
        transactionDateDisp: null,
        receivedFrom: null,
        depositAcct: null,
        bankNo: null,
        paymentMethod: null,
        cashBook: null,
        gstIO: null,
        gstStatus: null,
        gstRate: (0.00).toFixed(2),
        currency: null,
        amount: (0.00).toFixed(2),
        gstAmount: (0.00).toFixed(2),
        gstAmountAE: null,
        netAmount: (0.00).toFixed(2),
        bankAmount: (0.00).toFixed(2),
        bankAmountAE: null,
        bankCharges: (0.00).toFixed(2),
        bankTotalAmount: (0.00).toFixed(2),
        bankTotalLocal: (0.00).toFixed(2),
        bankTotalLocalAE: null,
        amountCurr: null,
        gstAmountCurr: null,
        netAmountCurr: null,
        bankAmountCurr: null,
        bankChargesCurr: null,
        bankTotalAmountCurr: null,
        bankTotalLocalCurr: null,
        printDocument: null,
        addressTo: null,
        policyNo: null,
        companyName: null,
        docAddress1: null,
        docAddress2: null,
        docAddress3: null,
        docAddress4: null,
        postalCode: null,
        details: null,
        statementRef: null,
        department: null,
        insuredName: null,
        claimNo: null,
        gstRegNo: null,
        taxInvoiceNo: null,
        payerBank: null,
        payersChequeNo: null,
        drawerName: null,
        creditCardNo: null,
        amountCurrRate: null,
        bankAmountCurrRate: null,
        actionName: null,
        bankTotalLocalCurrRate: (0.00).toFixed(2),
        isExistDocNo: null,
        insdRefNo: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      mulAcctRcptLabel: {
        branch: 'Branch*',
        accountNo: 'Account No',
        documentNo: 'Document No',
        docAE: 'Auto Receipt No.',
        transactionType: 'Transaction Type',
        fund: 'Fund*',
        accountNoSuffixDesc: 'Suffix',
        transactionDateDisp: 'Transaction Date*',
        receivedFrom: 'Received From*',
        depositAcct: 'Deposit Account*',
        paymentMethod: 'Payment Method*',
        cashBook: 'Cash Book',
        gstIO: 'GST IO*',
        gstStatus: 'Status*',
        gstRate: 'Rate*',
        currency: 'Currency',
        amount: 'Amount*',
        gstAmount: 'GST Amount',
        netAmount: 'Net Amount',
        bankAmount: 'Bank Amount',
        bankCharges: 'Bank Charges',
        bankTotalAmount: 'Bank Total Amount',
        bankTotalLocal: 'Bank Total Local',
        amountCurr: 'Amount Currency*',
        gstAmountCurr: 'GST Amount Currency',
        netAmountCurr: 'Net Amount Currency',
        bankAmountCurr: 'Bank Amount Currency',
        bankChargesCurr: 'Bank Charges Currency',
        bankTotalAmountCurr: 'Bank Total Amount Currency',
        bankTotalLocalCurr: 'Bank Total Local Currency',
        printDocument: 'Print Document',
        addressTo: 'Address To',
        policyNo: 'Policy No',
        companyName: 'Name',
        docAddress1: 'Address 1',
        docAddress2: 'Address 2',
        docAddress3: 'Address 3',
        docAddress4: 'Address 4',
        postalCode: 'Postal Code',
        details: 'Details',
        statementRef: 'Statement Reference',
        department: 'Department',
        insuredName: 'Insured Name',
        claimNo: 'Claim No',
        gstRegNo: 'GST Reg No',
        taxInvoiceNo: 'Their Tax Invoice No',
        payerBank: 'Payer Bank',
        payersChequeNo: 'Cheque No',
        drawerName: 'Drawer Name',
        creditCardNo: 'Credit Card No',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      accountList: [],
      selectAcctRcptColumns: ['receivedFrom', 'accountNoSuffixDesc', 'gstIO', 'gstStatus', 'gstRate', 'amount', 'gstAmountAE', 'gstAmount', 'netAmount', 'bankAmountAE', 'bankAmount', 'bankCharges', 'bankTotalAmount', 'bankTotalLocalAE', 'bankTotalLocal'],
      mulAcctRcptColumns: [
        { text: 'Received', value: 'receivedFrom' },
        { text: 'Suffix', value: 'accountNoSuffixDesc' },
        { text: 'GST', value: 'gstIO' },
        { text: 'Status', value: 'gstStatus' },
        { text: 'Rate', value: 'gstRate' },
        { text: 'Receipt ', value: 'amount' },
        { text: 'A/E', value: 'gstAmountAE' },
        { text: 'GST', value: 'gstAmount' },
        { text: 'Net', value: 'netAmount' },
        { text: 'A/E', value: 'bankAmountAE' },
        { text: 'Bank Amt', value: 'bankAmount' },
        { text: 'Charges', value: 'bankCharges' },
        { text: 'Total', value: 'bankTotalAmount' },
        { text: 'A/E', value: 'bankTotalLocalAE' },
        { text: 'Local Total', value: 'bankTotalLocal' }
      ],
      btnSaveList: false,
      nowDT: formatDisplayDateTime4(new Date()),
      createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
